import { SHIFT_STATUSES } from '@/modules/shift-and-reports/constants/shiftStatuses'
import { fetchCouriers } from '@/services/couriersService'
import { fetchReports as fetchReportsFromApi } from '@/services/reports'
import {
    closeShift,
    fetchShifts,
    getCurrentShift,
    getDivisionById,
    openShift,
} from '@/services/shiftService'

export default {
    async openShift({ commit }, { divisionId, cashierId, cashDeskId }) {
        try {
            const payload = {
                division_id: divisionId,
                cashier_id: cashierId,
                cash_desk_id: cashDeskId,
            }

            const response = await openShift(payload)
            commit(
                'SET_SHIFT_PROCESSING',
                response.data?.status === SHIFT_STATUSES.PENDING
            )
            commit('SET_CURRENT_SHIFT', response.data)
        } catch (error) {
            commit('SET_SHIFT_PROCESSING', false)
            console.error('Ошибка при открытии смены', error)
            throw error
        }
    },

    async closeShift({ commit, state }, { closedBy }) {
        try {
            const payload = {
                closed_by: closedBy,
            }
            const currentShiftId = state.currentShift?.id

            const response = await closeShift(currentShiftId, payload)
            commit(
                'SET_SHIFT_PROCESSING',
                response.data?.status === SHIFT_STATUSES.CLOSING
            )
            commit('SET_CURRENT_SHIFT', response.data)
        } catch (error) {
            commit('SET_SHIFT_PROCESSING', false)
            console.error('Ошибка при закрытии смены', error)
            throw error
        }
    },

    async getCurrentShift({ commit }, { divisionId, cashDeskId }) {
        try {
            const response = await getCurrentShift(divisionId, cashDeskId)
            commit('SET_CURRENT_SHIFT', response.data)
            commit(
                'SET_SHIFT_PROCESSING',
                response.data?.status === SHIFT_STATUSES.PENDING ||
                    response.data?.status === SHIFT_STATUSES.CLOSING
            )
        } catch (error) {
            console.error('Ошибка при получении текущей смены', error)
            throw error
        }
    },

    async fetchShifts(
        { commit },
        { divisionId, offset = 0, limit = 20, append = false }
    ) {
        try {
            const response = await fetchShifts(divisionId, offset, limit)
            commit('SET_WORK_SHIFTS', {
                items: response.data?.shifts ?? [],
                append,
            })
            commit('SET_WORK_SHIFTS_TOTAL', response.data?.total ?? 0)
        } catch (error) {
            console.error('Ошибка при получении списка смен', error)
            throw error
        }
    },

    async getCurrentDivision({ commit }, { divisionId }) {
        try {
            const response = await getDivisionById(divisionId)
            commit('SET_CURRENT_DIVISION', response.data)
            return response.data
        } catch (error) {
            console.error('Ошибка при получении подразделения', error)
            throw error
        }
    },

    async fetchCouriers({ commit }, { divisionId }) {
        if (!divisionId) {
            commit('SET_COURIERS', [])
            return
        }

        try {
            const response = await fetchCouriers(divisionId)
            const couriers = [
                { id: null, name: 'Все курьеры' },
                ...response.data.couriers,
            ]
            commit('SET_COURIERS', couriers)
        } catch (error) {
            console.error('Ошибка при получении списка курьеров', error)
            throw error
        }
    },

    async fetchReports({ commit }) {
        try {
            const response = await fetchReportsFromApi()
            const reportsFromApi = response.data?.reports ?? []

            // Форматируем каждый отчет, добавляя поле label
            const formattedReports = reportsFromApi.map(report => ({
                ...report,
                label: `Отчет ${report.id} - ${report.name}`,
            }))

            commit('SET_REPORTS', [...formattedReports])
        } catch (error) {
            console.error('Ошибка при получении списка отчетов', error)
            throw error
        }
    },
}
